// =============================================================================
// UTILS/WHATSAPP-ANALISE-CREDITO.TS - link de envio por WhatsApp (deep-link)
// =============================================================================
// Monta o link do WhatsApp (api.whatsapp.com) com phone (DDI 55) + texto.
// PURO - testável sem navegador.
// =============================================================================

const BASE_FORMULARIO = 'https://quintoandar.com.br/documentacao/comprador/credito/inicio';

// Normaliza o telefone para só-dígitos com DDI 55. Se já vier com 55 (>=12 díg.),
// mantém; senão prefixa 55 (Brasil). String vazia quando não há dígitos.
export function normalizarTelefoneWhatsApp(telefone: string): string {
  const digitos = (telefone ?? '').replace(/\D/g, '');
  if (!digitos) return '';
  return digitos.startsWith('55') && digitos.length >= 12 ? digitos : `55${digitos}`;
}

// Link do formulário de crédito (com o userId = idCstimob da operação).
export function linkFormularioCredito(idCstimob: number | string): string {
  return `${BASE_FORMULARIO}?userId=${idCstimob}`;
}

// Texto padrão da análise de crédito (usado como mensagem default/custom).
export function textoAnaliseCredito(idCstimob: number | string): string {
  return (
    '*Faça aqui sua análise de crédito*\n\n' +
    'Olá! Para adiantar o processo de financiamento, inicie já a sua análise de crédito clicando no link abaixo.\n\n' +
    `👉 *Preencher formulário de crédito* ${linkFormularioCredito(idCstimob)}`
  );
}

// Substitui as variáveis suportadas no corpo de um template:
//   {{nome}} → nome do comprador · {{link}} → link do formulário de crédito
export function resolverVariaveisMensagem(
  corpo: string,
  vars: { nome?: string; link?: string },
): string {
  return (corpo ?? '')
    .replace(/\{\{\s*nome\s*\}\}/gi, vars.nome ?? '')
    .replace(/\{\{\s*link\s*\}\}/gi, vars.link ?? '');
}

// Monta o deep-link do WhatsApp para um texto qualquer.
export function montarLinkWhatsApp(telefone: string, texto: string): string {
  const phone = normalizarTelefoneWhatsApp(telefone);
  return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(texto)}`;
}

// Atalho: link com a mensagem padrão de análise de crédito (compatível com o uso anterior).
export function montarLinkAnaliseCredito(telefone: string, idCstimob: number | string): string {
  return montarLinkWhatsApp(telefone, textoAnaliseCredito(idCstimob));
}
